<template>
    <button
		class="q-zendesk-launcher"
		:disabled="disabled"
		@click="onButtonClick"
	>
      <div
        class="q-zendesk-launcher__badge" 
        :class="{ 'opacity-0': unreadMessagesCount === 0 }"
      >
        {{ unreadMessagesCount }}
      </div>

      <div class="q-zendesk-launcher__content">
        <div class="q-zendesk-launcher__content--ico" :class="{ '-translate-y-50': isOpen }">
		  <v-icon large color="#fff">icon-q-support</v-icon>
		  <v-icon large color="#fff">icon-q-down</v-icon>
        </div>
      </div>
    </button>
</template>

<script>
export default {
    data() {
		return {
			isOpen: false,
			unreadMessagesCount: 0,
		}
    },
	created() {
		this.$zendesk.zE('messenger', 'close')

		this.$zendesk.zE('messenger:on', 'unreadMessages', (count) => {
			this.unreadMessagesCount = count
		})

		this.$zendesk.zE('messenger:on', 'open', () => {
			this.isOpen = true
			this.unreadMessagesCount = 0
		})

		this.$zendesk.zE('messenger:on', 'close', () => {
			this.isOpen = false
		})
	},
	computed: {
		disabled () {
			return this.$zendesk?.disabled ?? true
		},
	},
    methods: {
        onButtonClick() {
			if (this.isOpen) {
				this.$zendesk.zE('messenger', 'close')
				this.isOpen = false
			} else {
				this.$zendesk.zE('messenger', 'open')
				this.isOpen = true
			}
        },
    },
}
</script>

<style lang="scss">
	:root {
		--q-zendesk-bottom: 20px;
		--q-zendesk-right: 20px;
		--q-zendesk-launcher-height: 48px;
		--q-zendesk-launcher-width: 48px;
	}

	.opacity-0 {
		opacity: 0 !important;
	}

	.-translate-y-50 {
		transform: translateY(-50%) !important;
	}

	.q-zendesk-launcher {
		position: fixed;
		bottom: var(--q-zendesk-bottom);
		right: var(--q-zendesk-right);
		height: var(--q-zendesk-launcher-height);
		width: var(--q-zendesk-launcher-width);
		cursor: pointer;
		border: none;
		outline: none;
		background-color: #005851;
		border-radius: 50%;
		z-index: 10;
		box-shadow: 2px 2px 10px 0 rgba(0,0,0,0.25);

		&__content {
			position: relative;
			height: 100%;
			width: 100%;
			overflow: hidden;

			&--ico {
				position: absolute;
				top: 0;
				left: 0;
				height: 200%;
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: space-around;
				overflow: hidden;
				transition-property: transform;
				transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
				transition-duration: 300ms;
				transform: translateY(0px);
			}
		}

		&__badge {
			position: absolute;
			top: 0;
			right: 0;
			height: 20px;
			width: 20px;
			line-height: 20px;
			text-align: center;
			transform: translateX(25%) translateY(-25%);
			background-color: #ff0000;
			color: white;
			font-weight: 600;
			border-radius: 50%;
			font-size: 0.75rem;
			transition-property: opacity;
			transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
			transition-duration: 300ms;
		}
	}

	[title="Messaging window"][name="Messaging window"] {
		bottom: calc(var(--q-zendesk-bottom) * 2 + var(--q-zendesk-launcher-height)) !important;
		z-index: 9 !important;
	}
</style>
